export const DOCUMENT_TYPE_ARTICLE = 'article';
